<template>
  <div :class="isSurveyOnly ? 'post-survey' : 'enter-chat'">
    <div v-if="isSurveyOnly">
    </div>
    <div v-else-if="!isResumed && (!isHidingConversation || agentUnavailableVideo)">
      <div v-if="agentUnavailableVideo" style="height: 100%">
        <v-card
          class="elevation-16 mx-auto video-card"
          width="100%"
          height="100%"
          style="height: calc(100% - 13px)"
        >
          <video
            id="unavailableVideoMp4"
            v-if="agentUnavailableVideoMode == 'MP4'"
            controls
            ref="preVideo"
            muted="muted"
            autoplay
            loop
            style="height: 100%; width: 100%"
            playsinline
          >
            <source
              :src="widgetData.queueChecks.noAgent_VideoUrl"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <v-img
            v-if="agentUnavailableVideoMode == 'GIF'"
            :src="widgetData.queueChecks.noAgent_VideoUrl"
            style="height: 100%; width: 100%"
          />

          <v-snackbar
            v-if="
              widgetData.queueChecks.noAgent_QueueMsg &&
              widgetData.queueChecks.noAgent_QueueMsg != '' &&
              widgetData.queueChecks.noAgent_QueueMsg_Duration > 0
            "
            location="top"
            color="primary"
            v-model="isShowSnackbar"
            :timeout="widgetData.queueChecks.noAgent_QueueMsg_Duration"
          >
            {{ widgetData.queueChecks.noAgent_QueueMsg }}
          </v-snackbar>
        </v-card>
      </div>
      <div v-else-if="!widgetData.config.isKioskMode">
        <div class="header">
          <v-card flat class="mx-auto title" color="transparent">
            <v-card-title class="text">
              <img class="agent-icon-img" :src="widgetData.config.prechatLogo" />
              <div class="md-title">{{ enterChatView.title }}</div>
            </v-card-title>
          </v-card>
        </div>
        <div class="content">
          <v-card flat class="mx-auto fields-container" color="transparent">
            <v-card-text>
              <v-form ref="form" v-model="isFormValid" lazy-validation>
                <div
                  v-for="f in enterChatViewCloned.fields"
                  :key="f.optParamName"
                >
                  <v-text-field
                    :class="f.optParamName"
                    density="compact"
                    variant="outlined"
                    autocomplete="off"
                    v-if="f.type === 'text'"
                    v-model="f.value"
                    class="enter-chat-input-style"
                    :rules="getRules(f.regex, f.value)"
                    :label="f.label"
                    :single-line="!enterChatView.isPersistentLabels"
                    @keyup="onFieldKeyup()"
                  ></v-text-field>
                  <!-- <v-text-field
                    :class="f.optParamName"
                    dense
                    height="40"
                    variant="outlined"
                    :single-line="true" <------------------- this property is a replace of "solo"
                    autocomplete="off"
                    color="#fff"
                    v-if="f.type === 'text'"
                    v-model="f.value"
                    class="enter-chat-input-style"
                    :rules="getRules(f.regex, f.value)"
                    :label="f.label"
                    @keyup="onFieldKeyup()"
                  ></v-text-field> -->

                  <v-textarea
                    :class="f.optParamName"
                    density="compact"
                    height="40"
                    variant="outlined"
                    v-if="f.type === 'textarea'"
                    v-model="f.value"
                    :single-line="!enterChatView.isPersistentLabels"
                    class="enter-chat-input-style"
                    :label="f.label"
                    :rules="getRules(f.regex, f.value)"
                    @keyup="onFieldKeyup()"
                  ></v-textarea>
                  <v-select
                    :class="f.optParamName"
                    density="compact"
                    variant="outlined"
                    v-if="f.type === 'select'"
                    v-model:id="f.optParamName"
                    v-model:name="f.text"
                    :single-line="!enterChatView.isPersistentLabels"
                    class="enter-chat-input-style"
                    :label="f.label"
                    :rules="getRules(f.regex, f.value, 'select')"
                    :items="f.items"
                    @update:modelValue="onOptionSelect(f, $event)"
                  >
                  </v-select>
                  <div
                    v-html="f.text"
                    :class="f.id"
                    v-if="f.type === 'embededHTML'"
                  ></div>
                  <div v-if="f.type === 'checkbox'">
                    <input 
                      :class="f.optParamName"
                      type="checkbox"
                      :checked="String(f.value).toLowerCase() === 'true'"
                      @change="toggleValue(f)"
                      :disabled="$store.state.forceCallback===true && f.isCallback===true"
                      :id="f.optParamName"
                      :name="f.optParamName"
                    />
                    &nbsp;
                    <label
                        v-html="f.label"
                        class="v-label"
                        :for="f.optParamName"
                        :disabled="$store.state.forceCallback===true && f.isCallback===true"
                      ></label>
                  </div>
                  <div v-if="f.type === 'switch'">
                    <v-switch 
                      :class="f.optParamName"
                      :model-value="String(f.value).toLowerCase() === 'true'"
                      @change="toggleValue(f)"
                      :disabled="$store.state.forceCallback===true && f.isCallback===true"
                      :id="f.optParamName"
                      :name="f.optParamName"
                      :label="f.label"
                    />
                  </div>

                </div>
                <captcha v-if="enterChatView.isShowCaptcha && $store.state.captchaConfig.provider != 'Google'" />
                <div v-if="enterChatView.isShowCaptcha && $store.state.captchaConfig.provider == 'Google' && $store.state.captchaConfig.siteKey" id="googleCaptcha">
                  <RecaptchaV2
                    :language="$store.state.captchaConfig.language ? $store.state.captchaConfig.language : 'en'"
                    :size="$store.state.captchaConfig.size ? $store.state.captchaConfig.size : 'normal'"
                    :theme="$store.state.captchaConfig.theme ? $store.state.captchaConfig.theme : 'light'"
                    :siteKey="$store.state.captchaConfig.siteKey"
                  />
                </div>
                <v-card-actions>
                  <v-progress-linear
                  v-if="onRequestPending"
                  :indeterminate="true"
                ></v-progress-linear>
                  <v-btn
                    id="join-chat-btn"
                    :disabled="
                      !isFormValidationStarted ||
                      onRequestPending ||
                      !isFormValid ||
                      !isCaptchaPassed
                    "
                    v-if="!onRequestPending"
                    @click="onJoinChatClicked()"
                    type="submit"
                    >{{ enterChatView.btnJoinCallbackLabel && isCallback() ? enterChatView.btnJoinCallbackLabel : enterChatView.btnJoinChatLabel }}</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </div>
      </div>
      <div
        v-else-if="
          widgetData.config.isKioskMode &&
          !connectedToCallCenter &&
          (!isAgentAvailableCheckingConfigured || agentAvailableChecked)
        "
        style="height: 100%"
      >
        <v-card
          v-if="
            !$store.state.videoMessage &&
            kioskView.preVideoUrl &&
            kioskView.preVideoUrl !== ''
          "
          class="elevation-16 mx-auto video-card"
          width="100%"
          height="100%"
          style="height: calc(100% - 13px)"
        >
          <video
            id="preVideoMp4"
            controls
            ref="preVideo"
            muted="muted"
            autoplay
            loop
            style="height: 100%; width: 100%"
            playsinline
          >
            <source :src="kioskView.preVideoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <v-snackbar
            v-if="isShowWaitingInQueue"
            location="top"
            color="primary"
            v-model="isShowSnackbar"
            :timeout="200000000"
          >
            {{ kioskView.waitingInQueueMsg }}
          </v-snackbar>
        </v-card>
        <!-- in case there no any pre video content -->
        <v-card v-else color="transparent" class="waiting-content">
          <img class="waiting-image" :src="widgetData.config.prechatLogo" />
          <div class="waiting-title">{{ enterChatView.title }}</div>
          <div class="waiting-title" v-if="isShowWaitingInQueue">
            {{ kioskView.waitingInQueueMsg }}
          </div>
          <v-img
            v-if="conversationView.progressIconLink"
            class="waiting-title"
            :src="conversationView.progressIconLink"
          ></v-img>
          <v-img
            v-else-if="!conversationView.progressIconLink"
            class="waiting-title"
            :src="require('@/assets/Progress.svg')"
          ></v-img>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorService from "../services/ErrorService";
import { mapGetters } from "vuex";
import Captcha from "../components/Captcha";
import RecaptchaV2 from "../components/RecaptchaV2";
import Utils from "../helpers/utils";
import VidyoService from "../services/VidyoService";
import { watch, getCurrentInstance } from "vue";
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
  name: "EnterChatView",
  props: ["doCheckAvailability"],
  mounted() {
    Utils.log.debug("EnterChatView mounted, isConnect=" + this.isConnect);
    watch(this.isAutoJoin, async(newVal, oldVal) => {
      if (newVal && !this.isSurveyOnly && !sessionStorage.getItem("cc_resumed")) {
        this.$store.commit("setCaptchaPassed", true);
        this.$store.commit("setAutoJoin", false); // For re-entry to wait until instructed with startChat
        if (
          !this.agentAvailableChecked &&
          this.isAgentAvailableCheckingConfigured
        ) {
          var available = await this.$store.dispatch("isAgentAvailable");
          this.agentAvailableChecked = true;
          this.$store.commit("setAvailabilityChecked", true);
          if (!available) {
            if (
              this.widgetData.queueChecks.noAgent_ErrorMsg &&
              this.widgetData.queueChecks.noAgent_ErrorMsg != ""
            )
              ErrorService.onChatError(null, {
                statusText: this.widgetData.queueChecks.noAgent_ErrorMsg,
              });
            else
              ErrorService.onChatError(null, {
                statusText: "No satisfying agents",
              });
            return;
          }
        }
        this.setDataBeforeJoinChat();
        this.joinChat();
      }
      return;
    });
  },
  data() {
    return {
      onRequestPending: false,
      isFormValid: false,
      isFormValidationStarted: false,
      enterChatViewCloned: {},
      isShowSnackbar: true,
      interval: null,
      isAllDevicesSet: false,
      maximizedAlreadyClicked: false,
      videoAlertAlreadyShown: false,
      audioAlertAlreadyShown: false,
      devicesCheckIntervalLimit: 4,
      intervalCounter: 0,
      isShowWaitingInQueue: false,
      rootWindow: null,
      agentUnavailableVideo: false,
      agentAvailable: false,
      agentAvailableChecked: false,
      agentUnavailableVideoMode: null,
      availabilityChecking: false,
      isSurveyOnly: this.$store.state.isSurveyOnly,
      skillsMap: [],
      isResumed: true
    };
  },
  components: {
    captcha: Captcha,
    RecaptchaV2: RecaptchaV2,
  },
  computed: {
    ...mapGetters([
      "appData",
      "enterChatView",
      "widgetData",
      "isCaptchaPassed",
      "conversationView",
      "kioskView",
      "connectedToCallCenter",
      "isAgentAvailableCheckingConfigured",
      "isAutoJoin",
      "isConnect"
    ]),
    isHidingConversation() {
      return this.$store.state.hideConversation;
    }
  },
  async created() {
    Utils.log.debug("EnterChatView created, isConnect=" + this.isConnect);

    if(sessionStorage.getItem("cc_resumed")) {
      if (!this.isConnect) {
        Utils.log.debug("EnterChatView was from a resumed call but is now not connected");  
        sessionStorage.removeItem("cc_resumed");
        this.isResumed = false;
      }
      else {
        Utils.log.debug("EnterChatView created exiting as call is resumed");
        this.isResumed = true;
        this.maximizedAlreadyClicked = true;
        this.initDevicesInterval();
        return;
      }
    } else {
      this.isResumed = false;
    }

    this.$EventBus.on("widgetId", (widgetId) => this.handleWidgetId(widgetId));
    this.$EventBus.on("errorCallback", () => this.handleErrorCalback());
    this.$EventBus.on("expiredCallback", () => this.handleExpiredCallback());
    this.$EventBus.on("loadCallback", (response) => this.handleLoadCallback(response));
    // Issue found with residue configs where load completes after view created - so check if loaded, listen for emit if not
    if (this.appData && (sessionStorage.getItem("cc_resumed") || localStorage.getItem("cc_zipLoaded"))) {
      Utils.log.debug("EnterChatView already loaded appData");
      this.handleAppDataLoaded();
    } else {
      Utils.log.debug("EnterChatView waiting to load appData");
      this.$EventBus.on("appDataLoaded", () => this.handleAppDataLoaded());
    }
  },
  async beforeUpdate() {

    if (this.$store.state.forceCallback==true)
        this.isCallback(); // Called for force CB overwrites values in form

    // For re-entry from external controller / resumption!
    if (sessionStorage.getItem("cc_resumed")) {
        Utils.initUnloadEventListener();
        //trigger "onJoinChat" , "MainView" listen it and start polling
        this.$EventBus.emit("onJoinChat");      
        return;
    }
    if (this.isAutoJoin && !this.isSurveyOnly) {
      this.$store.commit("setCaptchaPassed", true);
      this.$store.commit("setAutoJoin", false); // For re-entry to wait until instructed with startChat
      if (
        !this.agentAvailableChecked &&
        this.isAgentAvailableCheckingConfigured
      ) {
        var available = await this.$store.dispatch("isAgentAvailable");
        this.agentAvailableChecked = true;
        this.$store.commit("setAvailabilityChecked", true);
        if (!available) {
          if (
            this.widgetData.queueChecks.noAgent_ErrorMsg &&
            this.widgetData.queueChecks.noAgent_ErrorMsg != ""
          )
            ErrorService.onChatError(null, {
              statusText: this.widgetData.queueChecks.noAgent_ErrorMsg,
            });
          else
            ErrorService.onChatError(null, {
              statusText: "No satisfying agents",
            });
          return;
        }
      }
      this.joinChat();
    }
  },
  methods: {
    //return true if all devices sets, false if not.
    checkAllDevicesSetsSeperatedly() {
      Utils.log.debug("on checkAllDevicesSetsSeperatedly");
      return new Promise((resolve, reject) => {
        Promise.all([
          navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((data) => {
              Utils.log.debug("video data", data);
            })
            .catch((err) => {
              Utils.log.debug(err);
              /* handle the error */
              if (!this.videoAlertAlreadyShown) {
                let message =
                  this.widgetData.errorAlerts.videoInputError +
                  this.widgetData.errorAlerts.videoInputErrorLink;
                ErrorService.displayAlert(message, "error");
                this.videoAlertAlreadyShown = true;
                Utils.postMessageObject(
                  "error",
                  this.widgetData.errorAlerts.videoInputError
                );
              }
              if (this.widgetData.config.abortOnVideoInputError) {
                reject();
              }
            }),
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((data) => {
              Utils.log.debug("audio data", data);
            })
            .catch((err) => {
              Utils.log.debug(err);
              if (!this.audioAlertAlreadyShown) {
                /* handle the error */
                let message =
                  this.widgetData.errorAlerts.audioInputError +
                  this.widgetData.errorAlerts.audioInputErrorLink;
                ErrorService.displayAlert(message, "error");
                this.audioAlertAlreadyShown = true;
                Utils.postMessageObject(
                  "error",
                  this.widgetData.errorAlerts.audioInputError
                );
              }
              if (this.widgetData.config.abortOnAudioInputError) {
                reject();
              }
            }),
        ]).then((values) => {
          resolve();
        });
      })
        .then(() => {
          return true;
        })
        .catch((err) => {
          Utils.log.debug(err);
          return false;
        });
    },

    //return true if all devices sets, false if not.
    checkAllDevicesSetsTogether() {
      Utils.log.debug("on checkAllDevicesSetsTogether");
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((data) => {
            Utils.log.debug("video data", data);
          })
          .catch((err) => {
            Utils.log.debug(err);
            /* handle the error */
            if (!this.videoAlertAlreadyShown) {
              let message =
                this.widgetData.errorAlerts.videoAudioInputError +
                this.widgetData.errorAlerts.videoAudioInputErrorLink;
              ErrorService.displayAlert(message, "error");
              this.videoAlertAlreadyShown = true;
              Utils.postMessageObject(
                "error",
                this.widgetData.errorAlerts.videoInputError
              );
            }
            reject();
          })
          .then((values) => {
            resolve();
          });
      })
        .then(() => {
          return true;
        })
        .catch((err) => {
          Utils.log.debug(err);
          return false;
        });
    },

    //check if devices are sets and ready
    initDevicesInterval() {
      if (!this.$store.getters.widgetData.config.enableVideo) {
        Utils.log.debug("setDevices interval skipping device initialisation as enableVideo not true.");
        if (sessionStorage.getItem("cc_resumed")) {
          Utils.log.debug("EnterChatView can be bypassed for chat resumption");
          this.$router.push("ConversationView");
        }
        return;
      }
      this.interval = setInterval(
        async () => {
          if (this.intervalCounter >= this.devicesCheckIntervalLimit) {
            clearInterval(this.interval);
            Utils.log.debug(
              "setDevices interval exceeded the limit, therefore cleared.. " +
                this.intervalCounter +
                " " +
                this.devicesCheckIntervalLimit
            );
          } else {
            this.intervalCounter++;
            Utils.log.debug(
              `setDevices interval iteration number ${this.intervalCounter} started..`
            );
            this.isAllDevicesSet = 
              this.widgetData.config.isPromptForCamAndMicTogether ||
              Utils.isSafari()
                ? await this.checkAllDevicesSetsTogether()
                : await this.checkAllDevicesSetsSeperatedly();
            if (!this.isAllDevicesSet) {
              Utils.postMessageObject("status", "Not all devices sets");
              Utils.log.debug("Not all devices sets");
            } else {
              clearInterval(this.interval);
              Utils.log.debug("setDevices interval cleared..");
              VidyoService.init();

              if (sessionStorage.getItem("cc_resumed")) {
                Utils.log.debug("EnterChatView can be bypassed for chat resumption");
                this.$router.push("ConversationView");
                return;
              }

              if (this.widgetData.config.isKioskMode) {
                this.isShowWaitingInQueue = true;
                this.$EventBus.on("connectedToCallCenterEvent", () => {
                  if (
                    !this.connectedToCallCenter &&
                    !this.widgetData.config.isKioskNoChatUntilVideo
                  ) {
                    this.$store.commit("setConnectedToCallCenter", true);
                    let vid = document.getElementById("preVideoMp4");
                    if (vid) {
                      vid.pause();
                      vid.currentTime = 0;
                      vid.volume = 0;
                      vid.remove();
                    }
                    if (
                      this.$store.state.availabilityChecked != true &&
                      this.isAgentAvailableCheckingConfigured
                    )
                      this.$store.commit("setHideConversation", true);
                    else this.$store.commit("setHideConversation", false);
                    this.$router.push("ConversationView");
                  }
                });
                if (
                  this.widgetData.config.openAsNewWindow ||
                  this.maximizedAlreadyClicked
                ) {
                  this.$store.commit("setDataBeforeJoinKiosk");
                  this.joinChat();
                }
              }
            }
          }
        },
        this.widgetData.enterChatView.devicesCheckIntervalTime
          ? this.widgetData.enterChatView.devicesCheckIntervalTime
          : 5000
      );
    },

    //on option selected on DDL
    onOptionSelect(config, selected) {
      this.onFieldKeyup();
      if (config.isJoinChatDDL) {
        let fullSelectedObj = config.items.find((el) => el.value == selected);
        //for specific joinChat (like motors/health) object from data.json
        if (fullSelectedObj.joinChatData) {
          this.$store.commit("setJoinChat", fullSelectedObj.joinChatData);
        } else {
          this.$store.commit("setJoinChat", null);
        }
      }
      config.value = selected;
      this.skillsMap = this.skillsMap.filter(item => item.label != config.label);
      var cfgSel = config.items.filter(item => item.value == selected);
      if (cfgSel && cfgSel.length > 0 && cfgSel[0].skill && cfgSel[0].skill != '')
        this.skillsMap.push({label: config.label, skill: cfgSel[0].skill});
      return selected;
    },

    onFieldKeyup() {
      if (this.$refs.form && this.$refs.form.validate) {
        this.isFormValidationStarted = true;
        this.$refs.form.validate();
      }
    },

    getRules(regexStr, v, isSelect) {
      if (regexStr) {
        if(isSelect)
          return [(v) => !!v || ""];
        let regex = new RegExp(regexStr);
        // "" is empty message while not validate - some message can insert instead
        let ans = [(v) => regex.test(v) || ""]
        return ans;
      }
      return [true];
    },

    onJoinChatClicked() {
      if (!this.isCaptchaPassed) return; // in case of change the button disable via css.
      this.setDataBeforeJoinChat();
      this.joinChat();
    },
    async checkAvailability(attempt) {
      if (this.isAgentAvailableCheckingConfigured)
        Utils.log.debug(
          "Checking agent availability, attempt :" +
            attempt +
            " of " +
            this.widgetData.queueChecks.maxPolling
        );
      var queue = null;
      if (this.$store.state.appData.JoinChatData && this.$store.state.appData.JoinChatData.Call_Center_QueueName)
        queue = this.$store.state.appData.JoinChatData.Call_Center_QueueName;
      var available = await this.$store.dispatch("isAgentAvailable", queue);
      this.agentAvailableChecked = true;
      this.$store.commit("setAvailabilityChecked", true);
      if (available) {
        Utils.log.debug("Agent available");
        this.agentAvailable = true;
        this.agentUnavailableVideo = false;
        this.joinChatPerform();
        return;
      }
      if (this.$store.state.appData.DataGlobal.callbackSDK && this.$store.state.appData.DataGlobal.callbackSDK != '') {
        var strCallbackNumber = null;
        this.enterChatViewCloned["fields"].forEach((it) => {
          if (it["isCallbackNumber"]) {
            strCallbackNumber = it.value;
          }
        });
        if (strCallbackNumber != null) {
          this.$store.commit("setForceCallback",{forced:true, message:this.widgetData.queueChecks.noAgent_ErrorMsg});
          if (this.isCallback()) { // Update form 
            this.onRequestPending = false;
            return;
          }
        }
      }

      attempt++;
      // Check if video to play, check if loop and recheck etc      
      var error = false;
      if (!this.isAgentAvailableCheckingConfigured) {
        Utils.log.debug("Agent unavailable - no queuechecks");
        error = true;
      }
      if (
        !this.widgetData.queueChecks.interval ||
        this.widgetData.queueChecks.interval < 1
      ) {
        Utils.log.debug("Agent unavailable - no recheck interval");
        error = true;
      } else if (
        !this.widgetData.queueChecks.maxPolling ||
        this.widgetData.queueChecks.maxPolling < attempt
      ) {
        Utils.log.debug("Agent unavailable - no recheck polling");
        error = true;
      }
      if (error) {
        this.agentUnavailableVideo = false;
        this.onRequestPending = false;
        if (
          this.widgetData.queueChecks.noAgent_ErrorMsg &&
          this.widgetData.queueChecks.noAgent_ErrorMsg != ""
        )
          ErrorService.onChatError(null, {
            statusText: this.widgetData.queueChecks.noAgent_ErrorMsg,
          });
        else
          ErrorService.onChatError(null, {
            statusText: "No satisfying agents",
          });
        return;
      }
      if (
        this.widgetData.queueChecks.noAgent_VideoUrl &&
        this.widgetData.queueChecks.noAgent_VideoUrl != ""
      ) {
        if (!this.agentUnavailableVideo)
          Utils.log.debug(
            "Agent unavailable - playing video until available or recheck expiry"
          );
        this.agentUnavailableVideo = true;
      }
      Utils.log.debug(
        "Agent unavailable - waiting " +
          this.widgetData.queueChecks.interval +
          "ms to recheck"
      );
      setTimeout(async () => {
        this.checkAvailability(attempt);
      }, this.widgetData.queueChecks.interval);
    },
    async callbackPerform() {
      try {
        this.agentUnavailableVideo = false;
        let res = await this.$store.dispatch("callback");
        this.onRequestPending = false;
        console.log(res);
        console.log(res);
        this.$router.push("AfterView");
      } catch (e) {
        this.onRequestPending = false;
        if (this.widgetData.config.externalController == true) {
          var err = e.message || e.name || "Failed";
          window.parent.postMessage({ CC: { joinFailed: err } }, "*");
        }
        if (e != {})
          ErrorService.onChatError(null, {
                  statusText: e.message ? e.message : "" + e
                });
      }
    },
    async joinChatPerform() {
      try {
        this.agentUnavailableVideo = false;
        // Hide conversation if availability unchecked & enabled, as that will show video while checking
        if (
          !this.$store.state.availabilityChecked &&
          this.isAgentAvailableCheckingConfigured
        )
          this.$store.commit("setHideConversation", true);

        // Check if another session has taken control - in case while we were preparing to submit this form another was submitted on another tab etc
        var curSession = localStorage.getItem("cc_sessionId");
        var mySession = sessionStorage.getItem("cc_sessionId");
        if (curSession && curSession != mySession && !this.$store.getters.isSCOverride) {        
          Utils.log.warn("joinChat another session has taken control " + curSession + " vs " + mySession);  
          try {
            sessionStorage.removeItem("cc_resumed");
            $("custom-chat").hide(); // hide me
            $("#chat-view").hide(); // hide me
            if (this.$store.getters.widgetData.conversationView.chatResumedMessage)
              toast.info(this.$store.getters.widgetData.conversationView.chatResumedMessage, {"bodyClassName":"toastResumedAlert", "autoClose":false});
          } catch (err) {
            Utils.log.debug("joinChatPerform another session has taken control but could not unload this", err);
          }
          return;
        }
        localStorage.setItem("cc_lastWrite", new Date());
        localStorage.setItem("cc_sessionId", mySession);      

        let res = await this.$store.dispatch("joinChat");
        this.onRequestPending = false;
        console.log(res);
        if (res.Command === "Error") {
          if (this.widgetData.config.externalController == true)
            window.parent.postMessage(
              { CC: { joinFailed: res.Error_Code || "Failed" } },
              "*"
            );
          ErrorService.onChatError(res.Error_Code, {
                statusText: res.statusText ? res.statusText : res.Command
              });
          return;
        }
        Utils.initUnloadEventListener();
        //trigger "onJoinChat" , "MainView" listen it and start polling

        this.$store.commit("joinChatSuccess", {
          res,
          userName: this.appData.JoinChatData.Calling_User_FirstName,
        });
        this.$EventBus.emit("onJoinChat");
        if (!this.widgetData.config.isKioskMode) {
          if (
            this.$store.state.availabilityChecked != true &&
            this.isAgentAvailableCheckingConfigured
          )
            this.$store.commit("setHideConversation", true);
          else this.$store.commit("setHideConversation", false);
          this.$router.push("ConversationView");
        }
      } catch (e) {
        this.onRequestPending = false;
        if (this.widgetData.config.externalController == true) {
          var err = e.message || e.name || "Failed";
          window.parent.postMessage({ CC: { joinFailed: err } }, "*");
        }
        if (e != {})
          ErrorService.onChatError(null, {
                  statusText: e.message ? e.message : "" + e
                });
      }
    },
    async joinChat() {
      try {
        this.onRequestPending = true;
        this.agentAvailable = false;
        this.agentAvailableChecked = false;
        this.$store.state.availabilityChecked = false;
        var callback = this.isCallback();
        Utils.log.debug("Callback chat = " + callback);
        if (callback == true) {
          this.callbackPerform();
        }
        else if (
          !this.isAgentAvailableCheckingConfigured ||
          this.widgetData.queueChecks.joinBeforeCheck
        )
          this.joinChatPerform();
        else 
          this.checkAvailability(1);
      } catch(error) {
        this.onRequestPending = false;
        ErrorService.onChatError(null, {
                statusText: error.message ? error.message : "" + error
              });
      }
    },

    isCallback() {
  if (
    this.$store.state.appData.DataGlobal.callbackSDK &&
    this.$store.state.appData.DataGlobal.callbackSDK !== ''
  ) {
    let strCallbackNumber = null;
    let bCallback = true; // Omitted or true isCallback permits CB if has CB number, only a false field will prevent

    // Ensure enterChatViewCloned["fields"] exists and is an array
    if (this.enterChatViewCloned && Array.isArray(this.enterChatViewCloned["fields"])) {
      this.enterChatViewCloned["fields"].forEach((it) => {
        if (it["isCallbackNumber"]) {
          strCallbackNumber = it.value;
        } else if (it["isCallback"]) {
          if (this.$store.state.forceCallback === true) {
            Utils.log.debug("Forced callback = true");
            it.value = true;
            if (
              this.$store.state.forceCallbackMessage &&
              !it.label.includes(this.$store.state.forceCallbackMessage)
            ) {
              Utils.log.debug("Forced callback message = " + this.$store.state.forceCallbackMessage);
              it.label += " <BR/>(" + this.$store.state.forceCallbackMessage + ")";
            }
          }
          if (it.value !== undefined) {
            bCallback = it.value;
          }
          Utils.log.debug(
            `Field '${it.label}' is isCallback, value=${it.value} callback=${bCallback}`
          );
        }
      });
    } else {
      Utils.log.debug("enterChatViewCloned['fields'] is not defined or is not an array");
    }

    const isCB = strCallbackNumber !== null && String(bCallback).toLowerCase() === "true";
    Utils.log.debug("IsCallback returning " + isCB);
    return isCB;
  }
  Utils.log.debug("IsCallback returning false");
  return false;
},
    setDataBeforeJoinChat() {
      let strCallbackNumber,
        strFirstName,
        strLastName,
        strUserSubject = null;


      //set strFirstName
      this.enterChatViewCloned["fields"].forEach((it) => {
        if (it["isCallbackNumber"]) {
          strCallbackNumber = it.value;
          return;
        }
      });

      //set strFirstName
      this.enterChatViewCloned["fields"].forEach((it) => {
        if (it["isFirstName"]) {
          strFirstName = it.value;
          return;
        }
      });

      //set strLastName
      this.enterChatViewCloned["fields"].forEach((it) => {
        if (it["isLastName"]) {
          strLastName = it.value;
          return;
        }
      });

      //set strUserSubject
      this.enterChatViewCloned["fields"].forEach((it) => {
        if (it["isSubject"]) {
          strUserSubject = it.value;
          return;
        }
      });

      var callback = this.isCallback();
      var skillsCsv = this.skillsMap.map((s) => s.skill).join(callback ? ',' : '+');
      if (callback) {
        this.$store.commit("setDataBeforeCallback", {
          strCallbackNumber,
          strFirstName,
          strLastName,
          strUserSubject,
          fields: this.enterChatViewCloned.fields,
          skills: skillsCsv
        });
      } else {
        if (this.widgetData.translationConfig) {
          this.setSourceLang();
        }
        this.$store.commit("setDataBeforeJoinChat", {
          strFirstName,
          strLastName,
          strUserSubject,
          fields: this.enterChatViewCloned.fields,
          skills: skillsCsv
        });
      }
    },

    //determine what is the src language
    setSourceLang() {
      try {
        if (
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.activationState &&
          this.widgetData.translationConfig.activationState.toUpperCase() == "DISABLED"
        ) {
          Utils.log.debug(`translationConfig activationState is DISABLED - skipping source language`);
          return;
        }

        let translationSourceLang = null;
        let translationSkill = null;
        //set translationSourceLang
        if (
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.detectionType.toUpperCase() ==
            "JSON" &&
          this.widgetData.translationConfig.sourceLanguage
        ) {
          Utils.log.debug(`translationConfig detectionType is JSON`);
          translationSourceLang =
            this.widgetData.translationConfig.sourceLanguage.toUpperCase();
        } else if (
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.detectionType.toUpperCase() == "DDL"
        ) {
          Utils.log.debug(`translationConfig detectionType is DDL`);
          this.enterChatViewCloned["fields"].forEach((it) => {
            if (it["isTranslationDDL"]) {
              translationSourceLang = it.value.toUpperCase();
              if (it.items && it.items.length > 0) {
                var cfgSel = it.items.filter(item => item.value == it.value);
                if (cfgSel && cfgSel.length > 0 && cfgSel[0].skill && cfgSel[0].skill != '')
                  translationSkill = cfgSel[0].skill;
              }
              return;
            }
          });
        } else if (
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.detectionType.toUpperCase() == "OP" &&
          this.$store.state.OptionalParameterFromAPI["sc_trsrclang"]
        ) {
          Utils.log.debug(`translationConfig detectionType is OP`);
          translationSourceLang =
            this.$store.state.OptionalParameterFromAPI[
              "sc_trsrclang"
            ].toUpperCase();
        }

        //finally - set the data
        this.$store.commit("setTranslationSkill", translationSkill);
        if (
          translationSourceLang &&
          translationSourceLang !== "" &&
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.detectionType.toUpperCase() !== "AUTO"
        ) {
          this.$store.commit("setTranslationSourceLang", translationSourceLang);
        } else if (
          this.widgetData.translationConfig &&
          this.widgetData.translationConfig.detectionType.toUpperCase() !==
            "AUTO" &&
          !translationSourceLang
        ) {
          if (this.widgetData.translationConfig.isShowAlerts) {
            ErrorService.displayAlert(
              this.widgetData.errorAlerts.translationSrcLangNotDefined
            );
          } else {
            Utils.log.error(
              this.widgetData.errorAlerts.translationSrcLangNotDefined
            );
          }
        }
      } catch(error) {
        Utils.log.warn("Error setting source language", error);  
        debugger;
      }
    },
    handleWidgetId(widgetId) {
      Utils.log.debug("Widget ID: ", widgetId);
    },
    handleErrorCalback() {
      Utils.log.debug("Error callback");
      this.$store.commit("setCaptchaToken", null);
      this.$store.commit("setCaptchaPassed", false);
    },
    handleExpiredCallback() {
      Utils.log.debug("Expired callback");
      this.$store.commit("setCaptchaToken", null);
      this.$store.commit("setCaptchaPassed", false);
    },
    handleLoadCallback(response) {
      Utils.log.debug("Load callback", response);
      this.$store.commit("setCaptchaToken", response);
      this.$store.commit("setCaptchaPassed", true);
    },
    handleAppDataLoaded() {
      Utils.log.debug("AppData loaded");
      this.appData.QueryOptionalParameters = [];
      let urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        if (key.startsWith("OP_"))
          this.appData.QueryOptionalParameters.push({
            key: key.substring(3),
            value: value,
          });
      });
      Utils.log.debug(urlParams.has("yourParam")); // true
      if (!this.isSurveyOnly) {
        if (this.widgetData.enterChatView.devicesCheckIntervalLimit) {
          this.devicesCheckIntervalLimit =
            this.widgetData.enterChatView.devicesCheckIntervalLimit;
        }
        if (this.isAgentAvailableCheckingConfigured) {
          if (
            this.widgetData.queueChecks.noAgent_VideoUrl &&
            this.widgetData.queueChecks.noAgent_VideoUrl
              .toLowerCase()
              .endsWith(".gif")
          )
            this.agentUnavailableVideoMode = "GIF";
          else if (
            this.widgetData.queueChecks.noAgent_VideoUrl &&
            this.widgetData.queueChecks.noAgent_VideoUrl
              .toLowerCase()
              .endsWith(".mp4")
          )
            this.agentUnavailableVideoMode = "MP4";
        }

        //clone the object, in order to not change the state without commit
        this.enterChatViewCloned = JSON.parse(JSON.stringify(this.enterChatView));

        //set strUserSubject
        this.enterChatViewCloned["fields"].forEach((field) => {
          if (field["items"]) {
            field["items"].forEach((item) => {
              if (item.title == undefined) item.title = item.text || item.value;
            });
          }
        });
      }

      if (!this.enterChatView.isShowCaptcha || this.autoJoin) {
        this.$store.commit("setCaptchaPassed", true);
      }
      if (!this.isSurveyOnly) {
        if (
          this.widgetData.config.videoVendor &&
          this.widgetData.config.videoVendor !== "" &&
          this.widgetData.config.isKioskMode
        ) {
          //maximizeClicked fired only when not openAsNewWindow
          this.$EventBus.on("maximizeClicked", () => {
            if(sessionStorage.getItem("cc_resumed")) return;
            this.maximizedAlreadyClicked = true;
            this.initDevicesInterval();
          });

          if (this.widgetData.config.openAsNewWindow) {
            this.initDevicesInterval();
          }
        }
        if (!this.agentAvailableChecked && this.doCheckAvailability)
          this.checkAvailability(1);
      }
    },
    provide(key, value) {
      provideV(key, value);
    },
    toggleValue(f) {
      Utils.log.debug("Toggle " + f.optParamName + " from " + f.value);
      if ((f.value == undefined) || String(f.value).toLowerCase() != 'true')
        f.value = true;
      else 
        f.value = false;
      Utils.log.debug("Toggle " + f.optParamName + " now " + f.value);
    }
  },
};
</script>

<style scoped>

.md-title {
  padding-top: 10px;
  font-size: 19pt;
  color: #fff;
  font-weight: bold;
}

.post-survey {
  width: 100%;
  height: 100%;
  background-color: #F5F8FC;
  overflow-y: auto;
}
.enter-chat {
  width: 100%;
  height: calc(100% - 62px);
  overflow-y: auto;
}
.enter-chat > .header {
  height: 74px;
}

.enter-chat .title .text {
  display: grid;
  justify-items: center;
  justify-content: center;
}

.enter-chat > .content {
  height: calc(100% - 60px);
  overflow-y: auto;
}

.enter-chat .waiting-content .waiting-image {
  max-width: 110px;
  max-height: 110px;
}

/* 
if input/select doesnt has "single-line" then this css should be unmurk, so the label wont be out of the input field margin
":deep(div.v-field__outline__notch > label) {
  max-width: 300px;
} */

</style>
